<template>
  <div>
    <div class="col-sm-12 col-xs-12 col-md-12 pl-24">
      <hr />
    </div>
    <div v-if="!passwordFlag">
      <div id="profile-body" class="col-sm-12 col-md-12 col-xs-12 pl-24">
        <div id="profile-icon" class="col-sm-6">
          <div class="col-sm-12 col-xs-5 xs-pd-lt-0">
            <div
              class="profile-pic-edit profile-pic-title-edit"
              v-if="loggedInInitialsFlag"
            ><span class="d-flex initials">{{getInitials(loggedInUser.first_name,loggedInUser.last_name)}}</span></div>
            <img class="profile-pic-edit" v-if="!loggedInInitialsFlag" :src="imageData" />
          </div>
          <div class="col-sm-12 col-xs-7 pd-0">
            <div class="col-xs-12 pd-0">
              <button class="btn chng-photo">
                {{$t('changePhoto')}}
                <input
                  type="file"
                  ref="fileImage"
                  @change="previewImage($event)"
                  accept="image/*"
                  class="file-upload-hide"
                  :title="this.$i18n.locale === 'Portuguese' ? 'Nenhum arquivo selecionado' : 'No file chosen'"
                />
              </button>
            </div>
            <div
              class="col-xs-12 pd-0"
            ><button class="font-properties cursor_pointer fs-16 ln-ht19 remove_photo" :disabled="loggedInInitialsFlag" @click="removePhotoUseInitials">{{$t('removePhoto')}}</button></div>
          </div>
        </div>
        <div
          id="profile-details"
          class="col-sm-6 col-md-6 col-xs-12 pl-0"
          v-if="Object.keys(loggedInUser).length"
        >
          <div class="row">
            <div class="col-sm-12 col-xs-12 label_name">{{$t('firstName')}} <span class="required">*</span></div>
            <div class="col-sm-12 col-xs-12 field_css xs-mr-bt-0">
              <input
                type="text"
                class="form-control"
                maxlength="35"
                name="first_name"
                @keyup="checkUpdatedFields($event)"
                v-model.trim="loggedInUser.first_name"
                :class="$v.loggedInUser.first_name.$error ? 'invalid-border' : ''"
                @blur="$v.loggedInUser.first_name.$touch()"
              />
              <div v-if="$v.loggedInUser.first_name.$error">
                <div
                  class="custom-error-class"
                  v-if="!$v.loggedInUser.first_name.required"
                >{{$t('completeRequiredField')}}</div>
                <div
                  class="custom-error-class"
                  v-else-if="!$v.loggedInUser.first_name.minLength"
                >{{$t('min2CharactersRequired')}}</div>
              </div>
            </div>
               <div class="col-sm-12 col-xs-12 label_name">{{$t('lastName')}} <span class="required">*</span></div>
            <div class="col-sm-12 col-xs-12 field_css xs-mr-bt-0">
              <input
                type="text"
                class="form-control"
                maxlength="30"
                name="last_name"
                @keyup="checkUpdatedFields($event)"
                v-model.trim="loggedInUser.last_name"
                :class="$v.loggedInUser.last_name.$error ? 'invalid-border' : ''"
                @blur="$v.loggedInUser.last_name.$touch()"
              />
               <div v-if="$v.loggedInUser.last_name.$error">
                <div
                  class="custom-error-class"
                  v-if="!$v.loggedInUser.last_name.required"
                >{{$t('completeRequiredField')}}</div>
                <div
                  class="custom-error-class"
                  v-else-if="!$v.loggedInUser.last_name.minLength"
                >{{$t('min2CharactersRequired')}}</div>
              </div>
            </div>
            <div class="col-sm-12 col-xs-12 label_name">Email <span class="required">*</span></div>
            <div class="col-sm-12 col-xs-12 field_css xs-mr-bt-0">
              <input
                type="text"
                class="form-control" readonly style="cursor:not-allowed"
                v-model="loggedInUser.email"
              />
            </div>
            <div class="col-sm-12 col-xs-12 label_name">{{$t('phoneNumber')}} <span class="required">*</span></div>
            <div class="col-sm-12 col-xs-12 field_css xs-mr-bt-0">
              <input
                type="text"
                class="form-control"
                size="15"
                name="phone"
                maxlength="20"
                @keyup="checkUpdatedFields($event)"
                v-model.trim="loggedInUser.phone"
                :class="$v.loggedInUser.phone.$error ? 'invalid-border' : ''"
                @blur="$v.loggedInUser.phone.$touch()"
                :readonly="roleId === 2 || roleId === 3 || roleId === roleInfo['RA Viewer']" :style="[(roleId === 2 || roleId === 3 || roleId === roleInfo['RA Viewer']) ?{'cursor':'not-allowed'} : '']"
              />
              <div v-if="$v.loggedInUser.phone.$error">
                <div
                  class="custom-error-class"
                  v-if="!$v.loggedInUser.phone.required"
                >{{$t('completeRequiredField')}}</div>
                <div
                  class="custom-error-class"
                  v-if="!$v.loggedInUser.phone.isNumber && $v.loggedInUser.phone.$error"
                >{{$t('enterOnlyNumbers')}}</div>
              </div>
            </div>
            <div class="col-sm-12 col-xs-12 label_name">{{$t('jobTitle')}}</div>
            <div class="col-sm-12 col-xs-12 field_css xs-mr-bt-0">
              <input
                type="text"
                class="form-control"
                maxlength="50"
                name="title"
                @keyup="checkUpdatedFields($event)"
                v-model.trim="loggedInUser.title"
                :class="$v.loggedInUser.title.$error ? 'invalid-border' : ''"
                @blur="$v.loggedInUser.title.$touch()"
                :readonly="roleId === 2 || roleId === 3 || roleId === roleInfo['RA Viewer']" :style="[(roleId === 2 || roleId === 3 || roleId === roleInfo['RA Viewer'])?{'cursor':'not-allowed'} : '']"
              />
              <div
                class="custom-error-class"
                v-if="!$v.loggedInUser.title.isAllowedCharacters && $v.loggedInUser.title.$error"
                >{{ specialCharacterErrMsg }}</div>
            </div>
          </div>
        </div>
      </div>
      <div class="footer col-xs-12 col-sm-12 d-flex-sm-end">
        <div class="xs-pd-lt-0">
          <button
            type="button"
            class="btn cancel_button"
            @click="$emit('closepopup', 'closeBasePopup')"
          >{{$t('cancel')}}</button>
        </div>
        <div class="xs-pd-lt-0 xs-pd-rt-0">
          <button
            type="button"
            class="btn save_changes_button"
            @click="updateProfile"
            :disabled="disableButtonForProfile || loaderStatus"
          >{{ $t('save')}}</button>
        </div>
      </div>
      <loader :loadingStatus="loaderStatus"></loader>
    </div>
    <div id="confirmPopup" class="modal fade" role="dialog">
      <div class="modal-dialog profile-confirm-poup">
        <!-- Modal content-->
        <div class="modal-content">
          <div class="modal-header confirmpopup-bgcolor">
            <button
              type="button"
              class="close"
              data-toggle="modal"
              data-target="#confirmPopup"
            >&times;</button>
          </div>
          <div
            class="modal-body confirm-body"
          >{{ $t('saveChangesMessage')}}</div>
          <div class="modal-footer confirmpopup-bgcolor">
            <div class="col-md-6 col-sm-6 col-xs-12 profile-footer-save">
              <button
                type="button"
                class="btn btn-block save-changes"
                @click="confirmChanges"
              >{{ $t('saveChanges')}}</button>
            </div>
            <div class="col-md-6 col-sm-6 col-xs-12">
              <button
                type="button"
                class="btn btn-block discard-changes"
                @click="cancelConfirmPopUp"
              >{{ $t('discardChanges')}}</button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import $ from 'jquery';
import { required, minLength } from 'vuelidate/lib/validators';
import { isNumber, isAllowedCharacters } from '../Register/validator';
import Loader from '../UIComponents/Loader.vue';
import EventBus from '../../utils/event-bus';
import { updateProfileData, getProfileData, getUserData } from '../../apis/profile';

export default {
  components: {
    Loader,
  },
  props: ['closeSubPage', 'roleInfo'],
  data() {
    return {
      infoActive: false,
      infoActiveAcct: false,
      errors: [],
      loaderStatus: false,
      loggedInInitialsFlag: false,
      imageData: '',
      imageExists: false,
      loggedInUser: {},
      passwordFlag: false,
      disableButtonForProfile: true,
      changePasswordNavHold: false,
      closeBasePopup: 'default',
      specialCharacterErrMsg: 'The following characters are not allowed: * ? < > ! @ # $ “ % ^',
      currentTargetedField: '',
      roleId: JSON.parse(localStorage.getItem('userData')).role_id,
      removePhoto: true,
    };
  },
  validations: {
    loggedInUser: {
      first_name: {
        minLength: minLength(2),
        required,
      },
      last_name: {
        minLength: minLength(2),
        required,
      },
      phone: {
        required,
        isNumber,
      },
      title: {
        isAllowedCharacters,
      },
    },
  },
  async created() {
    if (!this.passwordFlag) this.loadProfile();
    this.userData = localStorage.getItem('userData') ? JSON.parse(localStorage.getItem('userData')) : await getUserData();
    await this.getProfileData();
  },
  watch: {
    closeSubPage(val) {
      if (val === 'close') {
        this.unsetPasswordFlag();
      }
    },
  },
  computed: {
  },
  methods: {
    clearNotifcations() {
      this.$notify({
        clear: true,
        group: 'custom-notification',
      });
    },

    async confirmChanges() {
      $('#confirmPopup').modal('toggle');
      await this.updateProfile();
    },
    cancelConfirmPopUp() {
      this.disableButtonForProfile = true;
      $('#confirmPopup').modal('toggle');
      if (this.changePasswordNavHold) {
        this.setPasswordFlag();
      } else {
        this.$emit('closedConfirmPopup', this.closeBasePopup);
        this.closeBasePopup = 'default';
      }
    },
    toggleConfirmPopUp(closeBasePopup = 'default') {
      this.closeBasePopup = closeBasePopup;
      $('#confirmPopup').modal('toggle');
    },
    checkUpdatedFields(event) {
      if (event) {
        this.currentTargetedField = event.currentTarget.name;
      }
      const response = JSON.parse(localStorage.getItem('userData'));
      if (this.loggedInUser.first_name === '' || this.loggedInUser.last_name === '' || this.loggedInUser.phone === '' || this.loggedInUser.first_name.length < 2 || this.loggedInUser.last_name.length < 2) {
        this.disableButtonForProfile = true;
        return;
      }
      if (this.currentTargetedField === 'title' && this.loggedInUser.title.length === 0) {
        this.disableButtonForProfile = false;
        return;
      }
      if (this.currentTargetedField === 'title' && this.loggedInUser.title.length !== 0) {
        if (isAllowedCharacters(this.loggedInUser.title) && response.title !== this.loggedInUser.title) {
          this.disableButtonForProfile = false;
        } else {
          this.disableButtonForProfile = true;
        }
        return;
      }
      if (this.currentTargetedField === 'phone' && !(Number(this.loggedInUser.phone))) {
        this.disableButtonForProfile = true;
        return;
      }
      if (response.first_name !== this.loggedInUser.first_name
      || response.last_name !== this.loggedInUser.last_name
      || response.title !== this.loggedInUser.title
      || response.phone !== this.loggedInUser.phone) {
        this.disableButtonForProfile = false;
        return;
      }
      if (response.profile_pic === null || response.profile_pic === '') {
        if (this.imageData !== null && this.imageData !== '') {
          this.disableButtonForProfile = false;
          return;
        }
      } else if (this.imageData === null || this.imageData === '') {
        this.disableButtonForProfile = false;
        return;
      }
      if (response.profile_pic !== null || response.profile_pic !== '') {
        if (this.imageData !== null && this.imageData !== '' && (response.profile_pic !== this.imageData || this.removePhoto)) {
          this.disableButtonForProfile = false;
          // this.similarEntries();
          return;
        }
      }
      this.disableButtonForProfile = true;
    },
    similarEntries() {
      const response = JSON.parse(localStorage.getItem('userData'));
      if (response.first_name === this.loggedInUser.first_name
      || response.last_name === this.loggedInUser.last_name
      || response.title === this.loggedInUser.title
      || response.phone === this.loggedInUser.phone) {
        this.disableButtonForProfile = true;
      }
    },
    deactivateModal() {
      $('.deactive-modal').modal('show');
    },
    closePopup() {
      $('.deactive-modal').modal('hide');
    },
    removePhotoUseInitials() {
      this.loggedInInitialsFlag = true;
      this.imageData = '';
      this.checkUpdatedFields();
      this.removePhoto = true;
    },
    async updateProfile() {
      this.loaderStatus = true;
      const data = {
        first_name: this.loggedInUser.first_name,
        last_name: this.loggedInUser.last_name,
        company: this.loggedInUser.company,
        email: this.loggedInUser.email,
        phone: this.loggedInUser.phone,
      };
      if (this.loggedInUser.title) data.title = this.loggedInUser.title;
      if (this.imageData) data.profile_pic = this.imageData;
      const response = await updateProfileData(data);
      if (response) {
        this.clearNotifcations();
        this.$notify({
          type: 'success',
          title: this.$i18n.locale === 'Portuguese' ? 'Sucesso' : 'Success',
          text: this.$i18n.locale === 'Portuguese' ? 'Perfil atualizado com sucesso!' : 'Profile updated successfully!',
          group: 'custom-notification',
        });
        await this.getProfileData();
        this.disableButtonForProfile = true;
        this.loaderStatus = false;
      }
    },
    async getProfileData() {
      this.loaderStatus = true;
      const userDataStorage = await getProfileData();
      if (userDataStorage) {
        localStorage.setItem('profileData', JSON.stringify(userDataStorage));
        EventBus.$emit('updateProfile', true);
      }
      const userData = JSON.parse(localStorage.getItem('userData'));
      if (userData && userData.id === userDataStorage.id) localStorage.setItem('userData', JSON.stringify(userDataStorage));
      this.loaderStatus = false;
    },
    previewImage(event) {
      const input = event.target;
      const fileLoader = this.$refs.fileImage;
      if (input.files && input.files[0]) {
        const fileExtension = (input.files[0].name.split('.'))[input.files[0].name.split('.').length - 1];
        if (input.files[0].size > 2097152) {
          this.clearNotifcations();
          this.$notify({
            type: 'error',
            title: this.$i18n.locale === 'Portuguese' ? 'Erro' : 'Error',
            text: 'File size cannot exceed 2MB',
            group: 'custom-notification',
          });
          fileLoader.value = null;
        } else if (fileExtension.toLowerCase() !== 'jpeg' && fileExtension.toLowerCase() !== 'png' && fileExtension.toLowerCase() !== 'jpg') {
          this.clearNotifcations();
          this.$notify({
            type: 'error',
            title: this.$i18n.locale === 'Portuguese' ? 'Erro' : 'Error',
            text: 'File should be of type jpg/png',
            group: 'custom-notification',
          });
          fileLoader.value = null;
        } else {
          const reader = new FileReader();
          reader.onload = (e) => {
            this.imageData = e.target.result;
            this.loggedInInitialsFlag = false;
            fileLoader.value = null;
            // this.disableButtonForProfile = false;
            this.checkUpdatedFields();
          };
          reader.readAsDataURL(input.files[0]);
        }
      }
    },

    async loadProfile() {
      this.loaderStatus = true;
      this.loggedInUser = {};
      const response = localStorage.getItem('profileData') ? JSON.parse(localStorage.getItem('profileData')) : await getProfileData();
      this.loaderStatus = false;
      this.loggedInUser = response;
      this.imageData = response.profile_pic;
      this.imageExists = true;
      localStorage.setItem('profileData', JSON.stringify(response));
      if (this.imageData === '' || this.imageData == null) {
        this.loggedInInitialsFlag = true;
        this.imageExists = false;
      } else {
        this.loggedInInitialsFlag = false;
      }
      EventBus.$emit('updateProfile', true);
    },
    getInitials(firstname, lastname) {
      return `${firstname ? firstname.charAt(0).toUpperCase() : ''}${lastname ? lastname.charAt(0).toUpperCase() : ''}`;
    },
  },
};
</script>

<style scoped>
#profile-body::-webkit-scrollbar {
  width: 6px;
}
#profile-body::-webkit-scrollbar-thumb {
  background: #D9D9D9;
  border-top-left-radius: 18px;
  border-bottom-left-radius: 18px;
}
.initials {
  margin-top: 37%;
  font-size: 64px;
  justify-content: center;
  line-height: 59px;
}
.profile-pic-title-edit {
  background: #CCCCCC;
  color: #000000;
  text-align: center;
  font-size: 50px;
  font-weight: 500;
}
.required {
  color: #C02032;
}
.custom-error-class{
  margin-top: 0px;
  margin-bottom: 5px;
  border-bottom-left-radius: 5px;
  border-bottom-right-radius: 5px;
  background-color: #ffebeb;
  padding: 8px;
  padding-left: 15px;
  color: #a20000;
  list-style-type: none;
  display: block;
  font-size: .8em;
  text-align: center;
}
.label_name {
  font-size: 16px;
  color: #3E3E3E;
  font-weight: 400;
}
.modal.deactive-modal {
  background: #00000000;
}
.deactive-modal .modal-dialog {
  position: fixed;
  right: -212px;
  bottom: -30px;
}
.modal-content.deactivate-acct{
  width: 493px;
}
.deactivate-acct .expiry-img {
  padding: 6px 19px 0px 0px;
}
.deactivate-acct .modal-title span {
  padding-top: 3px;
  color: #000000;
  font-weight: 500;
  font-size: 24px;
  line-height: 28px;
}
.deactivate-acct .deactivate-body {
  font-weight: 500;
  font-size: 14px;
  line-height: 16px;
  color: rgba(0, 0, 0, 0.7);
  padding: 0px 19px 24px 71px;
}
.modal-header.upgradeModal-bgcolor {
  background-color: #ffffff;
  border: 0px;
  border-top-left-radius: 10px;
  border-top-right-radius: 10px;
  padding: 13px 11px 0px 19px;
}
.modal-footer.cancelModal-bgcolor {
  background-color: #ffffff;
  border: 0px;
  border-radius: 10px;
  padding: 0px 15px 16px 0px;
}
.proceed-btn {
  padding: 7px 0px;
  width: 136px;
}
.please-cancel,
.please-cancel:hover,
.please-cancel:active  {
  font-weight: 500;
  font-size: 18px;
  line-height: 21px;
  color: #0B3C61;
  background: #FFFFFF;
  text-align: center;
}
.limit_popover_txt{
  text-align: left;
  word-break: normal;
}
.support-access {
  padding-top: 10px;
  padding-right: 35px;
  text-align: left;
}
.ml-6{
  margin-left: 6px;
}
.info-img {
  height: 18px;
  width: 18px;
}
.ul-checkbox .cr{
  top: 2px;
}
.profile-footer-save {
  float: right;
}
.profile-confirm-poup {
  width: 500px;
}
.confirm-body {
  padding: 5% 12%;
  margin-bottom: 10%;
  font-family: 'Open Sans';
  font-style: normal;
  font-weight: normal;
  font-size: 24px;
  line-height: 28px;
  text-align: center;
  color: #333333;
}
.modal-header .close {
  background: unset;
  opacity: 1;
  line-height: unset;
  width: unset;
  border-radius: unset;
  color: unset;
  font-weight: 300;
  font-size: 30px;
}
.confirmpopup-bgcolor {
  background-color: #ffffff;
  border: 0px;
  border-radius: 10px;
}
#profile-icon {
  text-align: center;
}
@media (min-width: 768px) {
  #profile-icon {
    float: right;
  }
}
.d-flex {
  display: flex;
}

/* .tooltiptext {
  visibility: hidden;
  width: 351px;
  background-color: #F2F2F2;
  color: rgba(0, 0, 0, 0.7);
  text-align: center;
  border-radius: 10px;
  padding: 16px;
  position: absolute;
  z-index: 1;
  top: 3.8em;
  left: -1em;
  margin-left: -60%;
  opacity: 1;
  transition: opacity 1s;
  box-shadow: 3px 4px 10px rgba(0, 0, 0, 0.5);
  font-size: 18px;
  line-height: 21px;
  font-weight: 400;
  text-align: left;
  word-break: break-word;
} */
/* .deactive-acct:hover .tooltiptext {
  visibility: visible;
  opacity: 1;
} */
/* .deactive-acct .tooltiptext::after {
  display: unset;
  position: absolute;
  pointer-events: none;
  content: "";
  transform: rotate(45deg);
  width: 1em;
  height: 1em;
  background: #F2F2F2;
  z-index: -10;
  top: -0.4em;
  left: 3.4em;
  box-shadow: none;
  margin: auto;
} */
.pt-15 {
  padding-top: 15px;
}
.pl-30 {
  padding-left: 30px;
}
.pl-20 {
  padding-left: 20px;
}
.pr-20 {
  padding-right: 20px;
}
.font-properties {
  font-family: 'Open Sans';
  font-style: normal;
}
.emergo-drk-blue {
  color: #0b3c61;
}
.fs-14 {
  font-size: 14px;
}
.fs-16 {
  font-size: 16px;
}
.fs-28 {
  font-size: 28px;
}
.line-ht-33 {
  line-height: 33px;
}
.line-ht-16 {
  line-height: 16px;
}
.ln-ht19 {
  line-height: 19px;
}
.font-weight-normal {
  font-weight: normal;
}
.font-weight-bold {
  font-weight: bold;
}
.font-weight-prop {
  font-weight: 300;
}
.prd-dtls-pd {
  padding: 10px 0px 0px 0px;
}
.header-profile {
  padding: 15px 0px 0px 20px;
  font-size: 28px;
  line-height: 33px;
  font-family: 'Open Sans';
  font-style: normal;
  font-weight: 300;
}
.remove_photo,.remove_photo:focus {
  color: #01518A;
  border: 0px;
  background-color: white;
  outline: none;
  font-size: 14px;
}
.remove_photo[disabled]{
  cursor: not-allowed;
}
.chng-photo {
  width: 180px;
  height: 44px;
  border: 1px solid #000001;
  border-radius: 3px;
  background: #ffffff;
  margin: 32px 0 10px 0;
  color: #000000;
}
.sec-pad {
  font-size: 16px;
  line-height: 19px;
  color: #0b3c61;
}
.sec-pad-line {
  padding: 10px 20px 0px 20px;
}
.icon-close {
  color: #333333 !important;
}
.form-control {
  padding: 6px 12px !important;
  border: 1px solid #4D4D4D;
  height: 40px;
  font-size: 16px;
  color: #4d4d4d;
}
.ml-10 {
  margin-left: 10px;
}
.header-chng-pwd {
  padding: 10px 0px 0 20px;
  font-size: 19px;
  line-height: 33px;
  font-family: 'Open Sans';
  font-style: normal;
  font-weight: 300;
}
.field_css {
  margin-bottom: 3%;
}
.profile-pic-edit {
  width: 180px;
  height: 180px;
  float: unset;
  border-radius: 50%;
}
.cursor_pointer {
  cursor: pointer;
}
.profile-pic-title-edit {
  display: inline-block !important;
}
.pd-0 {
  padding: 0px;
}
.footer {
  position: absolute;
  bottom: 0%;
  padding-right: 24px;
  padding-bottom: 2%;
  right: 0;
  background-color: #fff;
  border-bottom-left-radius: 4px;
  border-bottom-right-radius: 4px;
}
.file-upload-hide{
  margin: 0 auto;
  width:170px;
}
#profile-body {
  max-height: calc(84vh - 142px);
  overflow-y: auto;
  overflow-x: hidden;
}
.required {
  color: #C02032;
  font-size: 12px;
  position: relative;
  top: -2px;
}
.ps_lt_8_2 {
  left: 8.2em;
}
#divPasswordValidationResult {
  display: block;
  margin-top: 10px;
  padding: 5px;
  background: #ffffff;
  border: 1px solid #b00505;
  box-sizing: border-box;
  box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.25);
  border-radius: 10px;
}
.invalid-border {
  border-color: #a20000;
}
@media screen and (max-width: 374px) {
  .profile-confirm-poup {
    width: 250px;
  }
  .field_css.xs-mr-bt-0 {
    margin-bottom: 0%;
  }
  .profile-pic-edit {
    width: 55px;
    height: 55px;
    line-height: 55px;
    float: unset;
  }
  .chng-photo {
    width: 120px;
    font-size: 14px;
  }
  hr {
    margin-top: 10px;
    margin-bottom: 10px;
  }
  .support-access{
    text-align: left;
  }
}
@media screen and (max-width: 550px) {
  #profile-body {
    max-height: calc(84vh - 107px);
  }
}
@media (min-width: 375px) and (max-width: 767px) {
  .profile-confirm-poup {
    width: 300px;
  }
  .confirm-body {
    padding: 5% 5%;
    margin-bottom: 10%;
    font-size: 18px;
    line-height: 21px;
  }
  .profile-pic-edit {
    width: 85px;
    height: 85px;
    line-height: 85px;
    float: unset;
  }
  .chng-photo {
    width: 150px;
  }
}
@media screen and (max-width: 767px) {
  .profile-footer-save {
    float: unset;
    margin-bottom: 14px;
  }
  .footer {
    padding-bottom: 5%;
  }
  .xs-pd-lt-0 {
    padding-left: 0px;
  }
  .xs-pd-rt-0 {
    padding-right: 0px;
  }
}
@media screen and (max-width: 1023px){
  .support-access{
    text-align: left;
  }
}
@media (min-width: 768px)  and (max-width: 1024px) {
  #profile-body {
    max-height: calc(84vh - 295px);
  }
}
/* iphoneX landscape  */
@media (device-width: 812px) and (device-height: 375px){
  #profile-body {
    max-height: 52vh!important;
  }
  .changepassword_wrapper {
    max-height: 52vh!important;
    overflow-y: auto;
  }
}
</style>
